// On the create-user form, an admin account has no client segment — hide
// the "Type de compte" select when "Administrateur" is chosen. It's also
// disabled so it doesn't submit a stale value once hidden (the backend
// enforces the same rule regardless, but this keeps the payload honest).
function initClientTypeToggle() {
    const roleSelect = document.querySelector('#role');
    const clientTypeGroup = document.querySelector('[data-client-type-group]');
    const clientTypeSelect = clientTypeGroup?.querySelector('select');

    if (!roleSelect || !clientTypeGroup || !clientTypeSelect) {
        return;
    }

    const sync = () => {
        const isAdmin = roleSelect.value === 'ROLE_ADMIN';
        clientTypeGroup.hidden = isAdmin;
        clientTypeSelect.disabled = isAdmin;
    };

    roleSelect.addEventListener('change', sync);
    sync();
}

export default initClientTypeToggle;
